export const FORMEDIT_GET_FORM_LIST_BEGIN = 'FORMEDIT_GET_FORM_LIST_BEGIN';
export const FORMEDIT_GET_FORM_LIST_SUCCESS = 'FORMEDIT_GET_FORM_LIST_SUCCESS';
export const FORMEDIT_GET_FORM_LIST_FAILURE = 'FORMEDIT_GET_FORM_LIST_FAILURE';
export const FORMEDIT_GET_FORM_LIST_DISMISS_ERROR = 'FORMEDIT_GET_FORM_LIST_DISMISS_ERROR';
export const FORMEDIT_SUBMIT_FORM_BEGIN = 'FORMEDIT_SUBMIT_FORM_BEGIN';
export const FORMEDIT_SUBMIT_FORM_SUCCESS = 'FORMEDIT_SUBMIT_FORM_SUCCESS';
export const FORMEDIT_SUBMIT_FORM_FAILURE = 'FORMEDIT_SUBMIT_FORM_FAILURE';
export const FORMEDIT_SUBMIT_FORM_DISMISS_ERROR = 'FORMEDIT_SUBMIT_FORM_DISMISS_ERROR';
export const FORMEDIT_DELETE_FORM_BEGIN = 'FORMEDIT_DELETE_FORM_BEGIN';
export const FORMEDIT_DELETE_FORM_SUCCESS = 'FORMEDIT_DELETE_FORM_SUCCESS';
export const FORMEDIT_DELETE_FORM_FAILURE = 'FORMEDIT_DELETE_FORM_FAILURE';
export const FORMEDIT_DELETE_FORM_DISMISS_ERROR = 'FORMEDIT_DELETE_FORM_DISMISS_ERROR';
export const FORMEDIT_FORM_MODAL_CHANGE = 'FORMEDIT_FORM_MODAL_CHANGE';
export const FORMEDIT_CHOOSE_CURRENT_FORM = 'FORMEDIT_CHOOSE_CURRENT_FORM';
export const FORMEDIT_GET_FORMATTR_LIST_BEGIN = 'FORMEDIT_GET_FORMATTR_LIST_BEGIN';
export const FORMEDIT_GET_FORMATTR_LIST_SUCCESS = 'FORMEDIT_GET_FORMATTR_LIST_SUCCESS';
export const FORMEDIT_GET_FORMATTR_LIST_FAILURE = 'FORMEDIT_GET_FORMATTR_LIST_FAILURE';
export const FORMEDIT_GET_FORMATTR_LIST_DISMISS_ERROR = 'FORMEDIT_GET_FORMATTR_LIST_DISMISS_ERROR';
export const FORMEDIT_SUBMIT_FORMATTR_BEGIN = 'FORMEDIT_SUBMIT_FORMATTR_BEGIN';
export const FORMEDIT_SUBMIT_FORMATTR_SUCCESS = 'FORMEDIT_SUBMIT_FORMATTR_SUCCESS';
export const FORMEDIT_SUBMIT_FORMATTR_FAILURE = 'FORMEDIT_SUBMIT_FORMATTR_FAILURE';
export const FORMEDIT_SUBMIT_FORMATTR_DISMISS_ERROR = 'FORMEDIT_SUBMIT_FORMATTR_DISMISS_ERROR';
export const FORMEDIT_DELETE_FORMATTR_BEGIN = 'FORMEDIT_DELETE_FORMATTR_BEGIN';
export const FORMEDIT_DELETE_FORMATTR_SUCCESS = 'FORMEDIT_DELETE_FORMATTR_SUCCESS';
export const FORMEDIT_DELETE_FORMATTR_FAILURE = 'FORMEDIT_DELETE_FORMATTR_FAILURE';
export const FORMEDIT_DELETE_FORMATTR_DISMISS_ERROR = 'FORMEDIT_DELETE_FORMATTR_DISMISS_ERROR';
export const FORMEDIT_FORMATTR_MODAL_CHANGE = 'FORMEDIT_FORMATTR_MODAL_CHANGE';
export const FORMEDIT_CHOOSE_CURRENT_FORMATTR = 'FORMEDIT_CHOOSE_CURRENT_FORMATTR';
export const FORMEDIT_GET_FORMSUBMIT_LIST_BEGIN = 'FORMEDIT_GET_FORMSUBMIT_LIST_BEGIN';
export const FORMEDIT_GET_FORMSUBMIT_LIST_SUCCESS = 'FORMEDIT_GET_FORMSUBMIT_LIST_SUCCESS';
export const FORMEDIT_GET_FORMSUBMIT_LIST_FAILURE = 'FORMEDIT_GET_FORMSUBMIT_LIST_FAILURE';
export const FORMEDIT_GET_FORMSUBMIT_LIST_DISMISS_ERROR = 'FORMEDIT_GET_FORMSUBMIT_LIST_DISMISS_ERROR';
export const FORMEDIT_SUBMIT_FORMSUBMIT_BEGIN = 'FORMEDIT_SUBMIT_FORMSUBMIT_BEGIN';
export const FORMEDIT_SUBMIT_FORMSUBMIT_SUCCESS = 'FORMEDIT_SUBMIT_FORMSUBMIT_SUCCESS';
export const FORMEDIT_SUBMIT_FORMSUBMIT_FAILURE = 'FORMEDIT_SUBMIT_FORMSUBMIT_FAILURE';
export const FORMEDIT_SUBMIT_FORMSUBMIT_DISMISS_ERROR = 'FORMEDIT_SUBMIT_FORMSUBMIT_DISMISS_ERROR';
export const FORMEDIT_DELETE_FORMSUBMIT_BEGIN = 'FORMEDIT_DELETE_FORMSUBMIT_BEGIN';
export const FORMEDIT_DELETE_FORMSUBMIT_SUCCESS = 'FORMEDIT_DELETE_FORMSUBMIT_SUCCESS';
export const FORMEDIT_DELETE_FORMSUBMIT_FAILURE = 'FORMEDIT_DELETE_FORMSUBMIT_FAILURE';
export const FORMEDIT_DELETE_FORMSUBMIT_DISMISS_ERROR = 'FORMEDIT_DELETE_FORMSUBMIT_DISMISS_ERROR';
export const FORMEDIT_FORMSUBMIT_MODAL_CHANGE = 'FORMEDIT_FORMSUBMIT_MODAL_CHANGE';
export const FORMEDIT_CHOOSE_CURRENT_FORMSUBMIT = 'FORMEDIT_CHOOSE_CURRENT_FORMSUBMIT';






// WEBPACK FOOTER //
// ./src/features/formedit/redux/constants.js